module.exports = __webpack_public_path__ + "img/Icon-Development.fdfe026a.jpg";